import { useState } from 'react';

const useCustomHook = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isFromWallet, setIsFromWallet] = useState(false);
  const [generatedVouchers, setGeneratedVouchers] = useState([]);
  const [dataToExport, setDataToExport] = useState([]);
  const [titlesToExport, setTitlesToExport] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [targetUser, setTargetUser] = useState(null);
  const [isOpenMessageCartableDg, setIsOpenMessageCartableDg] = useState(false);
  const [requestId, setRequestId] = useState(null);

  return {
    isConfirmOpen,
    setIsConfirmOpen,
    isFromWallet,
    setIsFromWallet,
    generatedVouchers,
    setGeneratedVouchers,
    dataToExport,
    setDataToExport,
    titlesToExport,
    setTitlesToExport,
    totalCount,
    setTotalCount,
    targetUser,
    setTargetUser,
    loading,
    setLoading,
    activeStep,
    setActiveStep,
    isOpenMessageCartableDg, setIsOpenMessageCartableDg,
    requestId, setRequestId
  };
};

export default useCustomHook;
